
export default function BrandIntro() {
  return (
    <section className="py-24 bg-gradient-to-br from-pink-50 via-blue-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <div className="inline-block mb-6">
              <div className="flex space-x-2 mb-4">
                <div className="w-8 h-1 bg-pink-400"></div>
                <div className="w-8 h-1 bg-blue-400"></div>
                <div className="w-8 h-1 bg-teal-400"></div>
              </div>
            </div>
            
            <h2 className="text-5xl font-light text-gray-800 mb-8 tracking-wide leading-tight">
              艺术与工艺的
              <span className="block bg-gradient-to-r from-pink-500 via-blue-500 to-teal-500 bg-clip-text text-transparent">
                完美融合
              </span>
            </h2>
            
            <p className="text-xl text-gray-600 mb-8 font-light leading-relaxed">
              Gallery Jewelry 致力于将珠宝艺术推向新的高度。我们相信每一件珠宝都应该是独一无二的艺术品，承载着深刻的情感和美学价值。
            </p>
            
            <div className="space-y-6 mb-10">
              <div className="flex items-start">
                <div className="w-6 h-6 bg-gradient-to-r from-pink-400 to-pink-500 rounded-full flex items-center justify-center mr-4 mt-1">
                  <div className="w-3 h-3 flex items-center justify-center text-white">
                    <i className="ri-palette-line text-xs"></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-light text-gray-800 mb-2">艺术设计</h3>
                  <p className="text-gray-600 font-light">每一件作品都经过精心设计，融合当代艺术理念与传统工艺美学</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-6 h-6 bg-gradient-to-r from-blue-400 to-blue-500 rounded-full flex items-center justify-center mr-4 mt-1">
                  <div className="w-3 h-3 flex items-center justify-center text-white">
                    <i className="ri-hammer-line text-xs"></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-light text-gray-800 mb-2">精湛工艺</h3>
                  <p className="text-gray-600 font-light">传承百年工艺技法，结合现代制作技术，确保每一个细节完美无瑕</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-6 h-6 bg-gradient-to-r from-teal-400 to-teal-500 rounded-full flex items-center justify-center mr-4 mt-1">
                  <div className="w-3 h-3 flex items-center justify-center text-white">
                    <i className="ri-gem-line text-xs"></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-light text-gray-800 mb-2">顶级宝石</h3>
                  <p className="text-gray-600 font-light">严选全球最优质的宝石原料，确保每一颗宝石都具有卓越的品质</p>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <button className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-pink-400 via-blue-400 to-teal-400 text-white rounded-full font-light tracking-wide hover:from-pink-500 hover:via-blue-500 hover:to-teal-500 transition-all duration-300 cursor-pointer">
                <span className="mr-2">了解品牌故事</span>
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </button>
              
              <button className="inline-flex items-center justify-center px-8 py-4 border-2 border-gray-300 text-gray-700 rounded-full font-light tracking-wide hover:border-pink-400 hover:text-pink-500 bg-white hover:bg-pink-50 transition-all duration-300 cursor-pointer">
                <span className="mr-2">参观工坊</span>
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line"></i>
                </div>
              </button>
            </div>
          </div>
          
          {/* Image */}
          <div className="relative">
            <div className="aspect-w-4 aspect-h-5 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/a14bab541db499efa020c827967d0b78.jpg"
                alt="珠宝工艺师"
                className="w-full h-full object-cover"
              />
            </div>
            
            {/* Floating Elements */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-gradient-to-br from-pink-400 to-pink-500 rounded-full opacity-20"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-gradient-to-br from-blue-400 to-blue-500 rounded-full opacity-20"></div>
            <div className="absolute top-1/2 -right-4 w-16 h-16 bg-gradient-to-br from-teal-400 to-teal-500 rounded-full opacity-20"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
